import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  summary: string;
  author: string;
  publishDate: string;
  readCount: number;
  image: string;
  category: string;
}

export default function ArticleCard({
  id,
  title,
  summary,
  author,
  publishDate,
  readCount,
  image,
  category,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200 block"
    >
      <div className="relative h-44 overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
        />
        <div className="absolute top-3 left-3">
          <span className="bg-accent-500 text-white text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
            {category}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-semibold text-foreground-900 text-sm mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{summary}</p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-2">
            <span className="whitespace-nowrap">{author}</span>
            <span className="whitespace-nowrap">{publishDate}</span>
          </div>
          <div className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            <span className="whitespace-nowrap">{readCount.toLocaleString()}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}